import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { useCart } from '@src/quince-site-common/src/hooks/cart'
import { getGoldBarInCartErrorMessage } from '@src/quince-site-common/src/hooks/cart/constants/goldBar.constants'
import useFetch from '@src/quince-site-common/src/hooks/useFetch'
import ordersAndReturnService from '@src/quince-site-common/src/services/ordersAndReturnService'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'

import { getIsGoldBarProduct } from './utils'

export const useGoldBarProductEligibility = (
  product: Product | Bundle | undefined,
  setErrorMessage: (value: React.SetStateAction<string>) => void,
) => {
  const { t } = useTranslation('common')
  const isLoggedIn = AuthUtil.isLoggedIn()

  const { isGoldBarInCart } = useCart()
  const isGoldBarProduct = getIsGoldBarProduct(product)
  const isGoldBarAndInCart = isGoldBarProduct && isGoldBarInCart

  const { fetchData: getIsLoggedInUserEligbleForGoldBar, response: isLoggedInUserEligbleForGoldBarResponse } = useFetch(
    ordersAndReturnService.checkIfUserEligibleToBuyGoldBar,
    {},
  )

  const loggedInUserNotEligible = isLoggedIn && isGoldBarProduct && isLoggedInUserEligbleForGoldBarResponse === false
  const isGoldBarError = isGoldBarAndInCart || loggedInUserNotEligible

  useEffect(() => {
    if (isGoldBarError) setErrorMessage(getGoldBarInCartErrorMessage(t))
    else setErrorMessage('')
  }, [isGoldBarError, setErrorMessage])

  useEffect(() => {
    if (isLoggedIn && (isGoldBarProduct || isGoldBarInCart)) {
      getIsLoggedInUserEligbleForGoldBar().catch((err: unknown) => {
        console.error('error fetching getIsLoggedInUserEligbleForGoldBar', err)
      })
    }
  }, [isLoggedIn])

  return {
    isGoldBarError,
  }
}
